import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import { DialogActions, DialogContent } from "@mui/material";
import {
  Button,
  ColorPicker,
  CreatedUpdatedBy,
  Field,
  FieldsContainer,
  Form,
  PageHeader,
  TextField,
} from "common";
import { ParamsContext } from "common/components/Form/ParamsContext";
import HistoryListDialog from "features/histories/HistoryListDialog";
import useAccess from "features/profile/useAccess";
import I18n from "i18n";
import { createContext } from "react";
import useBoatForm, {
  UseBoatFormProps,
  UseBoatFormReturnType,
} from "./useBoatForm";
export const BoatContext = createContext<UseBoatFormReturnType | undefined>(
  undefined
);
export interface BoatFormProps extends UseBoatFormProps {}

export default function BoatForm({
  id,
  afterSave,
  onClose,
  defaultValues,
}: BoatFormProps) {
  const { hasPermissions, canEditItem } = useAccess();
  const form = useBoatForm({
    id,
    afterSave,
    defaultValues,
  });
  const {
    params,
    item,
    options,
    errors,
    loading,
    isDirty,
    isCreate,
    isUpdate,
    getIsDirty,
    getRequiredFields,
    onChange,
    save,
    saving,
  } = form;
  const title = isCreate ? I18n.t("Boat.addTitle") : item.name;
  const subtitle = isCreate ? undefined : undefined;
  return (
    <ParamsContext.Provider value={{ boat_id: id }}>
      <BoatContext.Provider value={form}>
        <PageHeader
          avatar={<DirectionsBoatIcon />}
          title={title}
          subtitle={subtitle}
          onClose={onClose}
          loading={loading}
        />
        <DialogContent>
          <Form
            loading={loading}
            item={item}
            options={options}
            errors={errors}
            onChange={onChange}
            translationCategory="Boat.attributes"
            translationPlaceholdersCategory="Boat.placeholders"
            translationHelpersCategory="Boat.helpers"
            isDirty={getIsDirty}
            requiredFields={getRequiredFields()}
            disabled={!canEditItem("boat", item)}
          >
            <FieldsContainer>
              <Field fullWidth>
                <TextField id="name" />
              </Field>
              <Field fullWidth>
                <TextField id="capacity" />
              </Field>
              <Field>
                <ColorPicker id="color" />
              </Field>
            </FieldsContainer>
          </Form>
        </DialogContent>
        <DialogActions>
          {isUpdate && (
            <CreatedUpdatedBy
              objectName="Boat"
              item={item}
              sx={{
                p: 1,
                paddingTop: 0,
                paddingBottom: 0.5,
                marginRight: "auto",
              }}
              renderDialog={
                hasPermissions(["history.viewany", "history.viewown"])
                  ? props => <HistoryListDialog {...props} subtitle={title} />
                  : undefined
              }
            />
          )}
          <Button
            title={I18n.t("App.save")}
            disabled={!isDirty}
            onClick={() => save()}
            loading={saving}
          />
        </DialogActions>
      </BoatContext.Provider>
    </ParamsContext.Provider>
  );
}
